export default "__VITE_ASSET__CNbumAnX__"